import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import styles from "./TwoColumn.module.scss";
import classnames from 'classnames';
import { Container } from "../Container/Container/Container";
import { MatchHeight } from "../Utility/MatchHeight/MatchHeight";
import { Background } from "../Background/Background";
import { VerticalSpacer } from "../VerticalSpacer/VerticalSpacer";
import { jsx as _jsx } from "react/jsx-runtime";
export var TwoColumn = function TwoColumn(_ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? {} : _ref$background,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$columnsReverse = _ref.columnsReverse,
    columnsReverse = _ref$columnsReverse === void 0 ? false : _ref$columnsReverse,
    _ref$rowsReverse = _ref.rowsReverse,
    rowsReverse = _ref$rowsReverse === void 0 ? false : _ref$rowsReverse,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$gutter = _ref.gutter,
    gutter = _ref$gutter === void 0 ? true : _ref$gutter,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? true : _ref$padding,
    _ref$mobilePadding = _ref.mobilePadding,
    mobilePadding = _ref$mobilePadding === void 0 ? true : _ref$mobilePadding,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '' : _ref$maxWidth,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 'none' : _ref$offset,
    _ref$columnOneConfig = _ref.columnOneConfig,
    columnOneConfig = _ref$columnOneConfig === void 0 ? {
      verticalAlign: 'top'
    } : _ref$columnOneConfig,
    _ref$columnTwoConfig = _ref.columnTwoConfig,
    columnTwoConfig = _ref$columnTwoConfig === void 0 ? {
      verticalAlign: 'top'
    } : _ref$columnTwoConfig,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? 'large' : _ref$breakpoint,
    _ref$verticalSpacer = _ref.verticalSpacer,
    verticalSpacer = _ref$verticalSpacer === void 0 ? {
      className: '',
      padding: 'none'
    } : _ref$verticalSpacer;
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx(VerticalSpacer, _objectSpread(_objectSpread({}, Object.assign({}, verticalSpacer, {
      padding: padding ? 'default' : verticalSpacer === null || verticalSpacer === void 0 ? void 0 : verticalSpacer.padding
    })), {}, {
      className: classnames({
        [styles.noWrapperMobilePadding]: mobilePadding === false,
        [styles.wrapperPadding]: padding
      }),
      children: /*#__PURE__*/_jsx("div", {
        style: {
          maxWidth: maxWidth
        },
        className: classnames({
          [styles.maxWidth]: maxWidth,
          [styles.columnsReverse]: columnsReverse,
          [styles.rowsReverse]: rowsReverse,
          [styles.gutter]: gutter
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: styles["breakpoint".concat(_capitalize(breakpoint))],
          children: /*#__PURE__*/_jsx(Container, {
            className: fullWidth ? styles.fullWidth : '',
            children: /*#__PURE__*/_jsx(MatchHeight, {
              children: /*#__PURE__*/_jsx("div", {
                className: styles.inner,
                children: React.Children.map(children, function (child, index) {
                  return /*#__PURE__*/_jsx("div", {
                    className: classnames('twoColumnColumnWrapper', styles.column, {
                      [styles.offset]: offset !== 'none',
                      [styles.offsetLeft]: offset === 'left' && index === 0,
                      [styles.offsetRight]: offset === 'right' && index === 1,
                      [styles.vertAlignTop]: (columnOneConfig === null || columnOneConfig === void 0 ? void 0 : columnOneConfig.verticalAlign) === 'top' && index === 0 || (columnTwoConfig === null || columnTwoConfig === void 0 ? void 0 : columnTwoConfig.verticalAlign) === 'top' && index === 1,
                      [styles.vertAlignCenter]: (columnOneConfig === null || columnOneConfig === void 0 ? void 0 : columnOneConfig.verticalAlign) === 'center' && index === 0 || (columnTwoConfig === null || columnTwoConfig === void 0 ? void 0 : columnTwoConfig.verticalAlign) === 'center' && index === 1,
                      [styles.vertAlignBottom]: (columnOneConfig === null || columnOneConfig === void 0 ? void 0 : columnOneConfig.verticalAlign) === 'bottom' && index === 0 || (columnTwoConfig === null || columnTwoConfig === void 0 ? void 0 : columnTwoConfig.verticalAlign) === 'bottom' && index === 1
                    }),
                    children: child
                  });
                })
              })
            })
          })
        })
      })
    }))
  }));
};